import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import React, { MouseEventHandler, ReactElement } from 'react';

import { TextRenderer } from 'APP/components/TextRenderer/TextRenderer';
import { MiniatureMessageLayout } from 'APP/main/ChatView/components/MiniatureMessageLayout/MiniatureMessageLayout';
import type { ChatMessage } from 'STORE/Messages/Message/ChatMessage/ChatMessage';

import styles from './E2ee.styles.m.css';

interface IE2eeProps {
  titleClassName?: string;
  textClassName?: string;
  iconClassName?: string;
  message: ChatMessage;
  title: string | ReactElement;
  onClick: MouseEventHandler;
  preventInteraction?: boolean;
}

export const E2ee: React.FC<IE2eeProps> = observer(
  ({
    titleClassName,
    textClassName,
    iconClassName,
    message,
    title,
    onClick,
    preventInteraction,
  }) => {
    if (!message) {
      return null;
    }

    const { linkPreview } = message.payload;

    const { text } = message.payload;

    return (
      <MiniatureMessageLayout
        titleClassName={titleClassName}
        iconClassName={iconClassName}
        title={title}
        messageId={message.id}
        onClick={onClick}
        imageUrl={linkPreview?.image?.url}
        preventInteraction={preventInteraction}
      >
        <TextRenderer
          isPlainText
          className={classNames(styles.text, textClassName)}
        >
          {text}
        </TextRenderer>
      </MiniatureMessageLayout>
    );
  }
);
